/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsBubbleMessageText: {
  name: 'bubble-message-text';
  data: string;
} = {
  name: 'bubble-message-text',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M2 5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H8.277l-3.248 1.949c-1.333.8-3.029-.16-3.029-1.715V5Zm18 0H4v14.234l3.248-1.949A2 2 0 0 1 8.277 17H20V5ZM7 9a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H8a1 1 0 0 1-1-1Zm1 3a1 1 0 1 0 0 2h4a1 1 0 1 0 0-2H8Z" fill="currentColor"/></svg>`,
};
